import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { Text16 } from 'atoms/typography';
import Avatar from 'components/user/Avatar';
import { MyClubLink } from 'components/user/MyClubLink';
import { Nickname } from 'components/user/Nickname';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useIntlContext } from 'contexts/intl';

import SettingsSection from '../SettingsSection';

const messages = defineMessages({
  title: {
    id: 'Settings.myReferrer.title',
    defaultMessage: 'My Referrer',
  },
});

const Root = styled(Horizontal)`
  color: var(--c-neutral-600);
`;

export const MyReferrer = () => {
  const { formatDate } = useIntlContext();
  const { currentUser } = useCurrentUserContext();
  if (!currentUser) return null;
  const { referrer } = currentUser;
  if (!referrer) return null;

  return (
    <SettingsSection title={messages.title}>
      <Root>
        <Avatar user={referrer} variant="medium" />
        <div>
          <Text16>{formatDate(referrer.createdAt)}</Text16>
          <MyClubLink user={referrer}>
            <Text16>
              <Nickname user={referrer} />
            </Text16>
          </MyClubLink>
        </div>
      </Root>
    </SettingsSection>
  );
};

export default MyReferrer;
